<div *appRoles="['Documentos.Modificar']">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
    <h1 mat-dialog-title>Editar documento</h1>
    <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
        <app-editar-documento></app-editar-documento>
    </div>
</div>
